import React from 'react';
import ReactDOM from 'react-dom/client';
import { StytchProvider } from '@stytch/react';
import { StytchUIClient } from '@stytch/vanilla-js';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import config from './config';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Stytch configuration
const stytchOptions = {
  cookieOptions: {
    opaqueTokenCookieName: 'svountCookie',
    jwtCookieName: 'svountSessionJwt',
    path: '/',
    availableToSubdomains: false,
    domain: '',
    secure: true,
    httpOnly: true,
    sameSite: 'strict'
  }
};

// Initialize Stytch client
const stytch = new StytchUIClient(config.stytch.publicToken);

root.render(
  <React.StrictMode>
    <StytchProvider stytch={stytch} stytchOptions={stytchOptions}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </StytchProvider>
  </React.StrictMode>
);